import * as React from 'react';

import { FireScreenEventOnMount } from 'util/analytics/fire-screen-event';
import { ThemedButton } from 'view/common/themed-button';

import type { InjectedIntlProps, MessageValue } from 'react-intl';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { resetLogin } from 'state/actions/login';

import { Container, Subtitle, Title } from './styled';

import messages from './messages';
import loginMessages from '../messages';
import ThemedBackButton from 'view/common/themed-back-button';
import { forgotPassword } from 'rest/login';
import type { AjaxError } from 'rxjs';
import type { HandleAjaxError } from 'state/actions/flags';

interface ForgotPasswordConfirmationProps {
    email: string;
    resetLoginAction: typeof resetLogin;
    helpCenterName: string;
    resetUrl: string;
    onBackButtonClick: () => void;
    onResendLinkError: (error: AjaxError) => HandleAjaxError;
    onResendSuccess: (
        titleMessage: FormattedMessage.MessageDescriptor,
        titleMessageValues?: { [key: string]: MessageValue }
    ) => void;
}

interface ForgotPasswordConfirmationPropsState {
    isSendingForgotPasswordEmail: boolean;
}

export class ForgotPasswordConfirmation extends React.Component<
    ForgotPasswordConfirmationProps & InjectedIntlProps,
    ForgotPasswordConfirmationPropsState
> {
    state = {
        isSendingForgotPasswordEmail: false,
    };
    onResendButtonClick = () => {
        this.setState({ isSendingForgotPasswordEmail: true });
        forgotPassword(this.props.resetUrl, this.props.email)
            .toPromise()
            .then(() => {
                this.setState({ isSendingForgotPasswordEmail: false });
                this.props.onResendSuccess(messages.resendSuccessMessage, { emailAddress: this.props.email });
            })
            .catch((err) => {
                this.setState({ isSendingForgotPasswordEmail: false });
                this.props.onResendLinkError(err);
            });
    };
    renderContent = () => {
        const { intl, email, helpCenterName, onBackButtonClick } = this.props;

        return (
            <>
                <ThemedBackButton appearance="link" onClick={onBackButtonClick} actionSubjectId="returnToLogin">
                    {intl.formatMessage(loginMessages.backButton)}
                </ThemedBackButton>
                <Title>{helpCenterName}</Title>
                <Subtitle>
                    <FormattedMessage {...messages.checkYourEmail} />
                </Subtitle>
                <div>{intl.formatMessage(messages.emailHasBeenSentMessage, { emailAddress: email })}</div>
                <ThemedButton
                    appearance="default"
                    onClick={this.onResendButtonClick}
                    actionSubjectId="returnToLogin"
                    shouldFitContainer
                    isLoading={this.state.isSendingForgotPasswordEmail}
                >
                    <FormattedMessage {...messages.resendResetPasswordLinkLabel} />
                </ThemedButton>
            </>
        );
    };
    render() {
        return (
            <Container data-test-id="forgot-password-container">
                <FireScreenEventOnMount />
                {this.renderContent()}
            </Container>
        );
    }
}

export default injectIntl(ForgotPasswordConfirmation);
